
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties from "@/services/properties/global/cpi-ppi";
import data, { selectChoices } from "@/services/data/global/cpi-ppi";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";
import { PnetInput } from "@previnet/vue-input";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user', 'customCategory', 'customLabel'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    PnetInput,
    TextArea,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [],
      esitoRegistrazione: null as any,
      categories,
      precSettingRamo: {
        vita: undefined,
        danni: undefined,
      },
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();

        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg = "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      if (
        properties.codProdottoProperty.value == undefined ||
        properties.codProdottoProperty.value == null ||
        properties.codProdottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.codProdottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    isRamoVita() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.ramo, ["13.1"]);
    },
    isRamoDanni() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.ramo, ["13.2"]);
    },
    initSettingRamo() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precSettingRamo.vita === undefined) {
        vm.precSettingRamo.vita = vm.isRamoVita();
      }
      if (vm.precSettingRamo.danni === undefined) {
        vm.precSettingRamo.danni = vm.isRamoDanni();
      }
    },
    changePiuTariffe() {
      const vm = this as any;

      if (selectChoices.piuTariffe.code == '2.2') {
        properties.codProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
      }
    },
    changeFineComm() {
      const vm = this as any;
      
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodCommercio.code == "16.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    changePremioTipologia() {
      const vm = this as any;
      properties.frazPremioProperty.value = "";
      properties.interessiFrazProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"])) {
        selectChoices.frazPremio = [];
        properties.frazPremioProperty.value = vm.ND;
        properties.frazPremioProperty.values = [];

        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isInteressiFrazionamentoND() {
      const vm = this as any;
      const isPremioAnnuo = vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"]);
      const isNoFraz = vm.multivaluesContain(selectChoices.frazPremio, ["23.6"]);

      return !isPremioAnnuo || isNoFraz;
    },
    isFrazionamentoMensile() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.1"]);
    },
    isFrazionamentoBimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.2"]);
    },
    isFrazionamentoTrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.3"]);
    },
    isFrazionamentoQuadrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.4"]);
    },
    isFrazionamentoSemestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.5"]);
    },
    changeFrazPremio() {
      const vm = this as any;
      properties.interessiFrazProperty.value = "";

      if (selectChoices.frazPremio.length == 0 || vm.multivaluesContain(selectChoices.frazPremio, ["23.6"])) {
        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    changeRamo() {
      const vm = this as any;

      
      const isChangedRamoVita = vm.precSettingRamo.vita != vm.isRamoVita();
      const isChangedRamoDanni = vm.precSettingRamo.danni != vm.isRamoDanni();

      vm.precSettingRamo.vita = vm.isRamoVita();
      vm.precSettingRamo.danni = vm.isRamoDanni();

      if (selectChoices.ramo.length == 0) {
        selectChoices.rischiAssicuratiRamoVita = [];
        properties.rischiAssicuratiRamoVitaProperty.value = vm.ND;
        properties.rischiAssicuratiRamoVitaProperty.values = [];

        selectChoices.rischiAssicuratiRamoDanni = [];
        properties.rischiAssicuratiRamoDanniProperty.value = vm.ND;
        properties.rischiAssicuratiRamoDanniProperty.values = [];

        properties.costiRamoVitaProperty.value = vm.ND;
        properties.costiRamoVitaProperty.valueSign = "";
        properties.costiRamoDanniProperty.value = vm.ND;
        properties.costiRamoDanniProperty.valueSign = "";

        properties.retrDistrVitaProperty.value = vm.ND;
        properties.retrDistrVitaProperty.valueSign = "";
        properties.retrDistrDanniProperty.value = vm.ND;
        properties.retrDistrDanniProperty.valueSign = "";
      } else {
        if (!vm.isRamoVita()) {
          selectChoices.rischiAssicuratiRamoVita = [];
          properties.rischiAssicuratiRamoVitaProperty.value = vm.ND;
          properties.rischiAssicuratiRamoVitaProperty.values = [];

          properties.costiRamoVitaProperty.value = vm.ND;
          properties.costiRamoVitaProperty.valueSign = "";

          properties.retrDistrVitaProperty.value = vm.ND;
          properties.retrDistrVitaProperty.valueSign = "";
        } else if (isChangedRamoVita) {
          properties.rischiAssicuratiRamoVitaProperty.value = "";
          properties.costiRamoVitaProperty.value = "";
          properties.costiRamoVitaProperty.valueSign = "%";
          properties.retrDistrVitaProperty.value = "";
          properties.retrDistrVitaProperty.valueSign = "%";
        }

        if (!vm.isRamoDanni()) {
          selectChoices.rischiAssicuratiRamoDanni = [];
          properties.rischiAssicuratiRamoDanniProperty.value = vm.ND;
          properties.rischiAssicuratiRamoDanniProperty.values = [];

          properties.costiRamoDanniProperty.value = vm.ND;
          properties.costiRamoDanniProperty.valueSign = "";

          properties.retrDistrDanniProperty.value = vm.ND;
          properties.retrDistrDanniProperty.valueSign = "";
        } else if (isChangedRamoDanni) {
          properties.rischiAssicuratiRamoDanniProperty.value = "";
          properties.costiRamoDanniProperty.value = "";
          properties.costiRamoDanniProperty.valueSign = "%";
          properties.retrDistrDanniProperty.value = "";
          properties.retrDistrDanniProperty.valueSign = "%";
        }
      }

      vm.changeRischiAssicurati();
    },
    changeRischiAssicurati() {
      const vm = this as any;

      if (selectChoices.rischiAssicuratiRamoVita.length == 0 &&
          selectChoices.rischiAssicuratiRamoDanni.length == 0) {
        selectChoices.decessoQualsiasiCausa.code = "30";
        selectChoices.decessoQualsiasiCausa.description = vm.ND;
        properties.decessoQualsiasiCausaProperty.code = "30";
        properties.decessoQualsiasiCausaProperty.value = vm.ND;
        properties.decessoQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.decessoDaInfortunio.code = "32";
        selectChoices.decessoDaInfortunio.description = vm.ND;
        properties.decessoDaInfortunioProperty.code = "32";
        properties.decessoDaInfortunioProperty.value = vm.ND;
        properties.decessoDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.decessoDaMalattia.code = "34";
        selectChoices.decessoDaMalattia.description = vm.ND;
        properties.decessoDaMalattiaProperty.code = "34";
        properties.decessoDaMalattiaProperty.value = vm.ND;
        properties.decessoDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteQualsiasiCausa.code = "36";
        selectChoices.invaliditaPermanenteQualsiasiCausa.description = vm.ND;
        properties.invaliditaPermanenteQualsiasiCausaProperty.code = "36";
        properties.invaliditaPermanenteQualsiasiCausaProperty.value = vm.ND;
        properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteDaInfortunio.code = "38";
        selectChoices.invaliditaPermanenteDaInfortunio.description = vm.ND;
        properties.invaliditaPermanenteDaInfortunioProperty.code = "38";
        properties.invaliditaPermanenteDaInfortunioProperty.value = vm.ND;
        properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteDaMalattia.code = "40";
        selectChoices.invaliditaPermanenteDaMalattia.description = vm.ND;
        properties.invaliditaPermanenteDaMalattiaProperty.code = "40";
        properties.invaliditaPermanenteDaMalattiaProperty.value = vm.ND;
        properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaQualsiasiCausa.code = "42";
        selectChoices.inabilitaTemporaneaQualsiasiCausa.description = vm.ND;
        properties.inabilitaTemporaneaQualsiasiCausaProperty.code = "42";
        properties.inabilitaTemporaneaQualsiasiCausaProperty.value = vm.ND;
        properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaDaInfortunio.code = "44";
        selectChoices.inabilitaTemporaneaDaInfortunio.description = vm.ND;
        properties.inabilitaTemporaneaDaInfortunioProperty.code = "44";
        properties.inabilitaTemporaneaDaInfortunioProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaDaMalattia.code = "46";
        selectChoices.inabilitaTemporaneaDaMalattia.description = vm.ND;
        properties.inabilitaTemporaneaDaMalattiaProperty.code = "46";
        properties.inabilitaTemporaneaDaMalattiaProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.malattieGravi.code = "48";
        selectChoices.malattieGravi.description = vm.ND;
        properties.malattieGraviProperty.code = "48";
        properties.malattieGraviProperty.value = vm.ND;
        properties.malattieGraviPrestazioneProperty.value = vm.ND;
        //
        selectChoices.ricoveroOspedaliero.code = "50";
        selectChoices.ricoveroOspedaliero.description = vm.ND;
        properties.ricoveroOspedalieroProperty.code = "50";
        properties.ricoveroOspedalieroProperty.value = vm.ND;
        properties.ricoveroOspedalieroPrestazioneProperty.value = vm.ND;
        //
        selectChoices.ricoveroGrandeInterventoChirurgico.code = "52";
        selectChoices.ricoveroGrandeInterventoChirurgico.description = vm.ND;
        properties.ricoveroGrandeInterventoChirurgicoProperty.code = "52";
        properties.ricoveroGrandeInterventoChirurgicoProperty.value = vm.ND;
        properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = vm.ND;
        //
        selectChoices.perditaImpiego.code = "54";
        selectChoices.perditaImpiego.description = vm.ND;
        properties.perditaImpiegoProperty.code = "54";
        properties.perditaImpiegoProperty.value = vm.ND;
        properties.perditaImpiegoPrestazioneProperty.value = vm.ND;
        //
        properties.altriRischiProperty.value = vm.ND;
      } else {
        const decessoQualsiasiCausaDefaultCode = "30";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.1"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.1"])) {
          selectChoices.decessoQualsiasiCausa.code = decessoQualsiasiCausaDefaultCode;
          selectChoices.decessoQualsiasiCausa.description = vm.ND;
          properties.decessoQualsiasiCausaProperty.code = decessoQualsiasiCausaDefaultCode;
          properties.decessoQualsiasiCausaProperty.value = vm.ND;
          properties.decessoQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoQualsiasiCausa.code == decessoQualsiasiCausaDefaultCode) {
          selectChoices.decessoQualsiasiCausa.description = "";
          properties.decessoQualsiasiCausaProperty.code = decessoQualsiasiCausaDefaultCode;
          properties.decessoQualsiasiCausaProperty.value = "";
          properties.decessoQualsiasiCausaPrestazioneProperty.value = "";
        }

        const decessoDaInfortunioDefaultCode = "32";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.2"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.2"])) {
          selectChoices.decessoDaInfortunio.code = decessoDaInfortunioDefaultCode;
          selectChoices.decessoDaInfortunio.description = vm.ND;
          properties.decessoDaInfortunioProperty.code = decessoDaInfortunioDefaultCode;
          properties.decessoDaInfortunioProperty.value = vm.ND;
          properties.decessoDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoDaInfortunio.code == decessoDaInfortunioDefaultCode) {
          selectChoices.decessoDaInfortunio.description = "";
          properties.decessoDaInfortunioProperty.code = decessoDaInfortunioDefaultCode;
          properties.decessoDaInfortunioProperty.value = "";
          properties.decessoDaInfortunioPrestazioneProperty.value = "";
        }

        const decessoDaMalattiaDefaultCode = "34";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.3"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.3"])) {
          selectChoices.decessoDaMalattia.code = decessoDaMalattiaDefaultCode;
          selectChoices.decessoDaMalattia.description = vm.ND;
          properties.decessoDaMalattiaProperty.code = decessoDaMalattiaDefaultCode;
          properties.decessoDaMalattiaProperty.value = vm.ND;
          properties.decessoDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoDaMalattia.code == decessoDaMalattiaDefaultCode) {
          selectChoices.decessoDaMalattia.description = "";
          properties.decessoDaMalattiaProperty.code = decessoDaMalattiaDefaultCode;
          properties.decessoDaMalattiaProperty.value = "";
          properties.decessoDaMalattiaPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteQualsiasiCausaDefaultCode = "36";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.4"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.4"])) {
          selectChoices.invaliditaPermanenteQualsiasiCausa.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          selectChoices.invaliditaPermanenteQualsiasiCausa.description = vm.ND;
          properties.invaliditaPermanenteQualsiasiCausaProperty.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          properties.invaliditaPermanenteQualsiasiCausaProperty.value = vm.ND;
          properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteQualsiasiCausa.code == invaliditaPermanenteQualsiasiCausaDefaultCode) {
          selectChoices.invaliditaPermanenteQualsiasiCausa.description = "";
          properties.invaliditaPermanenteQualsiasiCausaProperty.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          properties.invaliditaPermanenteQualsiasiCausaProperty.value = "";
          properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteDaInfortunioDefaultCode = "38";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.5"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.5"])) {
          selectChoices.invaliditaPermanenteDaInfortunio.code = invaliditaPermanenteDaInfortunioDefaultCode;
          selectChoices.invaliditaPermanenteDaInfortunio.description = vm.ND;
          properties.invaliditaPermanenteDaInfortunioProperty.code = invaliditaPermanenteDaInfortunioDefaultCode;
          properties.invaliditaPermanenteDaInfortunioProperty.value = vm.ND;
          properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteDaInfortunio.code == invaliditaPermanenteDaInfortunioDefaultCode) {
          selectChoices.invaliditaPermanenteDaInfortunio.description = "";
          properties.invaliditaPermanenteDaInfortunioProperty.code = invaliditaPermanenteDaInfortunioDefaultCode;
          properties.invaliditaPermanenteDaInfortunioProperty.value = "";
          properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteDaMalattiaDefaultCode = "40";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.6"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.6"])) {
          selectChoices.invaliditaPermanenteDaMalattia.code = invaliditaPermanenteDaMalattiaDefaultCode;
          selectChoices.invaliditaPermanenteDaMalattia.description = vm.ND;
          properties.invaliditaPermanenteDaMalattiaProperty.code = invaliditaPermanenteDaMalattiaDefaultCode;
          properties.invaliditaPermanenteDaMalattiaProperty.value = vm.ND;
          properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteDaMalattia.code == invaliditaPermanenteDaMalattiaDefaultCode) {
          selectChoices.invaliditaPermanenteDaMalattia.description = "";
          properties.invaliditaPermanenteDaMalattiaProperty.code = invaliditaPermanenteDaMalattiaDefaultCode;
          properties.invaliditaPermanenteDaMalattiaProperty.value = "";
          properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaQualsiasiCausaDefaultCode = "42";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.7"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.7"])) {
          selectChoices.inabilitaTemporaneaQualsiasiCausa.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          selectChoices.inabilitaTemporaneaQualsiasiCausa.description = vm.ND;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.value = vm.ND;
          properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaQualsiasiCausa.code == inabilitaTemporaneaQualsiasiCausaDefaultCode) {
          selectChoices.inabilitaTemporaneaQualsiasiCausa.description = "";
          properties.inabilitaTemporaneaQualsiasiCausaProperty.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.value = "";
          properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaDaInfortunioDefaultCode = "44";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.8"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.8"])) {
          selectChoices.inabilitaTemporaneaDaInfortunio.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          selectChoices.inabilitaTemporaneaDaInfortunio.description = vm.ND;
          properties.inabilitaTemporaneaDaInfortunioProperty.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          properties.inabilitaTemporaneaDaInfortunioProperty.value = vm.ND;
          properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaDaInfortunio.code == inabilitaTemporaneaDaInfortunioDefaultCode) {
          selectChoices.inabilitaTemporaneaDaInfortunio.description = "";
          properties.inabilitaTemporaneaDaInfortunioProperty.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          properties.inabilitaTemporaneaDaInfortunioProperty.value = "";
          properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaDaMalattiaDefaultCode = "46";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.9"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.9"])) {
          selectChoices.inabilitaTemporaneaDaMalattia.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          selectChoices.inabilitaTemporaneaDaMalattia.description = vm.ND;
          properties.inabilitaTemporaneaDaMalattiaProperty.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          properties.inabilitaTemporaneaDaMalattiaProperty.value = vm.ND;
          properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaDaMalattia.code == inabilitaTemporaneaDaMalattiaDefaultCode) {
          selectChoices.inabilitaTemporaneaDaMalattia.description = "";
          properties.inabilitaTemporaneaDaMalattiaProperty.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          properties.inabilitaTemporaneaDaMalattiaProperty.value = "";
          properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = "";
        }

        const malattieGraviDefaultCode = "48";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.10"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.10"])) {
          selectChoices.malattieGravi.code = malattieGraviDefaultCode;
          selectChoices.malattieGravi.description = vm.ND;
          properties.malattieGraviProperty.code = malattieGraviDefaultCode;
          properties.malattieGraviProperty.value = vm.ND;
          properties.malattieGraviPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.malattieGravi.code == malattieGraviDefaultCode) {
          selectChoices.malattieGravi.description = "";
          properties.malattieGraviProperty.code = malattieGraviDefaultCode;
          properties.malattieGraviProperty.value = "";
          properties.malattieGraviPrestazioneProperty.value = "";
        }

        const ricoveroOspedalieroDefaultCode = "50";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.11"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.11"])) {
          selectChoices.ricoveroOspedaliero.code = ricoveroOspedalieroDefaultCode;
          selectChoices.ricoveroOspedaliero.description = vm.ND;
          properties.ricoveroOspedalieroProperty.code = ricoveroOspedalieroDefaultCode;
          properties.ricoveroOspedalieroProperty.value = vm.ND;
          properties.ricoveroOspedalieroPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.ricoveroOspedaliero.code == ricoveroOspedalieroDefaultCode) {
          selectChoices.ricoveroOspedaliero.description = "";
          properties.ricoveroOspedalieroProperty.code = ricoveroOspedalieroDefaultCode;
          properties.ricoveroOspedalieroProperty.value = "";
          properties.ricoveroOspedalieroPrestazioneProperty.value = "";
        }

        const ricoveroGrandeInterventoChirurgicoDefaultCode = "52";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.12"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.12"])) {
          selectChoices.ricoveroGrandeInterventoChirurgico.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          selectChoices.ricoveroGrandeInterventoChirurgico.description = vm.ND;
          properties.ricoveroGrandeInterventoChirurgicoProperty.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          properties.ricoveroGrandeInterventoChirurgicoProperty.value = vm.ND;
          properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.ricoveroGrandeInterventoChirurgico.code == ricoveroGrandeInterventoChirurgicoDefaultCode) {
          selectChoices.ricoveroGrandeInterventoChirurgico.description = "";
          properties.ricoveroGrandeInterventoChirurgicoProperty.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          properties.ricoveroGrandeInterventoChirurgicoProperty.value = "";
          properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = "";
        }

        const perditaImpiegoDefaultCode = "54";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.13"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.13"])) {
          selectChoices.perditaImpiego.code = perditaImpiegoDefaultCode;
          selectChoices.perditaImpiego.description = vm.ND;
          properties.perditaImpiegoProperty.code = perditaImpiegoDefaultCode;
          properties.perditaImpiegoProperty.value = vm.ND;
          properties.perditaImpiegoPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.perditaImpiego.code == perditaImpiegoDefaultCode) {
          selectChoices.perditaImpiego.description = "";
          properties.perditaImpiegoProperty.code = perditaImpiegoDefaultCode;
          properties.perditaImpiegoProperty.value = "";
          properties.perditaImpiegoPrestazioneProperty.value = "";
        }

        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.14"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.14"])) {
          properties.altriRischiProperty.value = vm.ND;
        } else if (properties.altriRischiProperty.value == vm.ND) {
          properties.altriRischiProperty.value = "";
        }
      }
    },
    valorizzaTendine() {
      properties.piuTariffeProperty.code = selectChoices.piuTariffe.code;
      properties.piuTariffeProperty.value = selectChoices.piuTariffe.description;
      properties.compagniaProperty.values = selectChoices.compagnia
      properties.canaleProperty.values = selectChoices.canale;
      properties.distributoriProperty.values = selectChoices.distributori;
      properties.modDistribuzioneProperty.values = selectChoices.modDistribuzione;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.ramoProperty.values = selectChoices.ramo;
      properties.tipologiaGaranzieProperty.values = selectChoices.tipologiaGaranzie;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipologiaAssicurazioneProperty.code = selectChoices.tipologiaAssicurazione.code;
      properties.tipologiaAssicurazioneProperty.value = selectChoices.tipologiaAssicurazione.description;
      properties.premioTipologiaProperty.values = selectChoices.premioTipologia;
      properties.frazPremioProperty.values = selectChoices.frazPremio;
      properties.rischiAssicuratiRamoVitaProperty.values = selectChoices.rischiAssicuratiRamoVita;
      properties.rischiAssicuratiRamoDanniProperty.values = selectChoices.rischiAssicuratiRamoDanni;
      properties.decessoQualsiasiCausaProperty.code = selectChoices.decessoQualsiasiCausa.code;
      properties.decessoQualsiasiCausaProperty.value = selectChoices.decessoQualsiasiCausa.description;
      properties.decessoDaInfortunioProperty.code = selectChoices.decessoDaInfortunio.code;
      properties.decessoDaInfortunioProperty.value = selectChoices.decessoDaInfortunio.description;
      properties.decessoDaMalattiaProperty.code = selectChoices.decessoDaMalattia.code;
      properties.decessoDaMalattiaProperty.value = selectChoices.decessoDaMalattia.description;
      properties.invaliditaPermanenteQualsiasiCausaProperty.code = selectChoices.invaliditaPermanenteQualsiasiCausa.code;
      properties.invaliditaPermanenteQualsiasiCausaProperty.value = selectChoices.invaliditaPermanenteQualsiasiCausa.description;
      properties.invaliditaPermanenteDaInfortunioProperty.code = selectChoices.invaliditaPermanenteDaInfortunio.code;
      properties.invaliditaPermanenteDaInfortunioProperty.value = selectChoices.invaliditaPermanenteDaInfortunio.description;
      properties.invaliditaPermanenteDaMalattiaProperty.code = selectChoices.invaliditaPermanenteDaMalattia.code;
      properties.invaliditaPermanenteDaMalattiaProperty.value = selectChoices.invaliditaPermanenteDaMalattia.description;
      properties.inabilitaTemporaneaQualsiasiCausaProperty.code = selectChoices.inabilitaTemporaneaQualsiasiCausa.code;
      properties.inabilitaTemporaneaQualsiasiCausaProperty.value = selectChoices.inabilitaTemporaneaQualsiasiCausa.description;
      properties.inabilitaTemporaneaDaInfortunioProperty.code = selectChoices.inabilitaTemporaneaDaInfortunio.code;
      properties.inabilitaTemporaneaDaInfortunioProperty.value = selectChoices.inabilitaTemporaneaDaInfortunio.description;
      properties.inabilitaTemporaneaDaMalattiaProperty.code = selectChoices.inabilitaTemporaneaDaMalattia.code;
      properties.inabilitaTemporaneaDaMalattiaProperty.value = selectChoices.inabilitaTemporaneaDaMalattia.description;
      properties.malattieGraviProperty.code = selectChoices.malattieGravi.code;
      properties.malattieGraviProperty.value = selectChoices.malattieGravi.description;
      properties.ricoveroOspedalieroProperty.code = selectChoices.ricoveroOspedaliero.code;
      properties.ricoveroOspedalieroProperty.value = selectChoices.ricoveroOspedaliero.description;
      properties.ricoveroGrandeInterventoChirurgicoProperty.code = selectChoices.ricoveroGrandeInterventoChirurgico.code;
      properties.ricoveroGrandeInterventoChirurgicoProperty.value = selectChoices.ricoveroGrandeInterventoChirurgico.description;
      properties.perditaImpiegoProperty.code = selectChoices.perditaImpiego.code;
      properties.perditaImpiegoProperty.value = selectChoices.perditaImpiego.description;
    },
    cleanAllProperties() {
      properties.prodottoProperty.value = "";
      properties.codProdottoProperty.value = "";
      properties.piuTariffeProperty.code = ""; properties.piuTariffeProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.compagniaProperty.values = [];
      properties.canaleProperty.values = [];
      properties.distributoriProperty.values = [],
      properties.modDistribuzioneProperty.values = [];
      properties.mercatoProperty.values = [];
      properties.destinatariProperty.value = "";
      properties.targetMarketProperty.value = "";
      properties.descProdottoProperty.value = "";
      properties.lineaBusinessProperty.value = "";
      properties.ramoProperty.values = [];
      properties.tipologiaGaranzieProperty.values = [];
      properties.combinazioneGaranzieProperty.value = "";
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.tipologiaAssicurazioneProperty.code = ""; properties.tipologiaAssicurazioneProperty.value = "";
      properties.premioTipologiaProperty.values = [];
      properties.premioDescProperty.value = "";
      properties.frazPremioProperty.values = [];
      properties.durataProperty.value = "";
      properties.etaMaxAllaSottoscrizioneProperty.value = "";
      properties.etaMaxAllaScadenzaProperty.value = "";
      properties.docRichiestaProperty.value = "";
      properties.rischiAssicuratiRamoVitaProperty.values = [];
      properties.rischiAssicuratiRamoDanniProperty.values = [];
      properties.decessoQualsiasiCausaProperty.code = ""; properties.decessoQualsiasiCausaProperty.value = "";
      properties.decessoQualsiasiCausaPrestazioneProperty.value = "";
      properties.decessoDaInfortunioProperty.code = ""; properties.decessoDaInfortunioProperty.value = "";
      properties.decessoDaInfortunioPrestazioneProperty.value = "";
      properties.decessoDaMalattiaProperty.code = ""; properties.decessoDaMalattiaProperty.value = "";
      properties.decessoDaMalattiaPrestazioneProperty.value = "";
      properties.invaliditaPermanenteQualsiasiCausaProperty.code = ""; properties.invaliditaPermanenteQualsiasiCausaProperty.value = "";
      properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = "";
      properties.invaliditaPermanenteDaInfortunioProperty.code = ""; properties.invaliditaPermanenteDaInfortunioProperty.value = "";
      properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = "";
      properties.invaliditaPermanenteDaMalattiaProperty.code = ""; properties.invaliditaPermanenteDaMalattiaProperty.value = "";
      properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaQualsiasiCausaProperty.code = ""; properties.inabilitaTemporaneaQualsiasiCausaProperty.value = "";
      properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaDaInfortunioProperty.code = ""; properties.inabilitaTemporaneaDaInfortunioProperty.value = "";
      properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaDaMalattiaProperty.code = ""; properties.inabilitaTemporaneaDaMalattiaProperty.value = "";
      properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = "";
      properties.malattieGraviProperty.code = ""; properties.malattieGraviProperty.value = "";
      properties.malattieGraviPrestazioneProperty.value = "";
      properties.ricoveroOspedalieroProperty.code = ""; properties.ricoveroOspedalieroProperty.value = "";
      properties.ricoveroOspedalieroPrestazioneProperty.value = "";
      properties.ricoveroGrandeInterventoChirurgicoProperty.code = ""; properties.ricoveroGrandeInterventoChirurgicoProperty.value = "";
      properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = "";
      properties.perditaImpiegoProperty.code = ""; properties.perditaImpiegoProperty.value = "";
      properties.perditaImpiegoPrestazioneProperty.value = "";
      properties.altriRischiProperty.value = "";
      properties.costiRamoVitaProperty.value = "";
      properties.costiRamoDanniProperty.value = "";
      properties.interessiFrazProperty.value = "";
      properties.interessiFrazProperty.frazionamento = {
        mensile: "", mensileSign: "%",
        bimestrale: "", bimestraleSign: "%",
        trimestrale: "", trimestraleSign: "%",
        quadrimestrale: "", quadrimestraleSign: "%",
        semestrale: "", semestraleSign: "%",
      };
      properties.retrDistrVitaProperty.value = "";
      properties.retrDistrDanniProperty.value = "";
      properties.retrDistrSpecificheProperty.value = "";
      properties.noteProperty.value = "";

      selectChoices.piuTariffe = { code: "", description: "" };
      selectChoices.compagnia = [];
      selectChoices.canale = [];
      selectChoices.modDistribuzione = [];
      selectChoices.mercato = [];
      selectChoices.ramo = [];
      selectChoices.tipologiaGaranzie = [];
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipologiaAssicurazione = { code: "", description: "" };
      selectChoices.premioTipologia = [];
      selectChoices.frazPremio = [];
      selectChoices.rischiAssicuratiRamoVita = [];
      selectChoices.rischiAssicuratiRamoDanni = [];
      selectChoices.decessoQualsiasiCausa = { code: "", description: "" };
      selectChoices.decessoDaInfortunio = { code: "", description: "" };
      selectChoices.decessoDaMalattia = { code: "", description: "" };
      selectChoices.invaliditaPermanenteQualsiasiCausa = { code: "", description: "" };
      selectChoices.invaliditaPermanenteDaInfortunio = { code: "", description: "" };
      selectChoices.invaliditaPermanenteDaMalattia = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaQualsiasiCausa = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaDaInfortunio = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaDaMalattia = { code: "", description: "" };
      selectChoices.malattieGravi = { code: "", description: "" };
      selectChoices.ricoveroOspedaliero = { code: "", description: "" };
      selectChoices.ricoveroGrandeInterventoChirurgico = { code: "", description: "" };
      selectChoices.perditaImpiego = { code: "", description: "" };
    },
    setPropertiesDefaultCode() {
      const vm = this as any;

      if (properties.piuTariffeProperty.code == "") { properties.piuTariffeProperty.code = "2"; }
      if (properties.prodCommercioProperty.code == "") { properties.prodCommercioProperty.code = "16"; }
      if (properties.tipologiaAssicurazioneProperty.code == "") { properties.tipologiaAssicurazioneProperty.code = "20"; }
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      if (propCode !== undefined && propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
      } else if (propCode !== undefined && propCode.length > 0) {
        choices = { code: propCode, description: propValue };
      } else {
        choices = { code: '', description: '' };
      }

      return choices;
    },
    /*prefillCodeValue1: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      alert(property.code + " " + property.value);
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
        alert("A --> " + JSON.stringify(choices));
      } else if (propCode.length > 0) {
        choices = { code: propCode, description: propValue };
        alert("B --> " + JSON.stringify(choices));
      } else {
        choices = { code: '', description: '' };
        alert("C --> " + JSON.stringify(choices));
      }

      return choices;
    },*/
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;

      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            const prodotto = result.properties[0].value;
            const piuTariffeCode = result.properties[1].code;
            const piuTariffeValue = result.properties[1].value;
            const codProdottiCollegati = result.properties[2].value;
            const compagniaValues = result.properties[3].values;
            const canaleValues = result.properties[4].values;
            const distributoriValues = result.properties[5].values;
            const modDistribuzioneValues = result.properties[6].values;
            const mercatoValues = result.properties[7].values;
            const destinatari = result.properties[8].value;
            const targetMarket = result.properties[9].value;
            const descProdotto = result.properties[10].value;
            const lineaBusiness = result.properties[11].value;
            const ramoValues = result.properties[12].values;
            const tipologiaGaranzieValues = result.properties[13].values;
            const combinazioneGaranzie = result.properties[14].value;
            const prodCommercioCode = result.properties[15].code;
            const prodCommercioValue = result.properties[15].value;
            const inizioComm = result.properties[16].value;
            const fineComm = result.properties[17].value;
            const edizioneDIPAgg = result.properties[18].value;
            const tipologiaAssicurazioneCode = result.properties[19].code;
            const tipologiaAssicurazioneValue = result.properties[19].value;
            const premioTipologiaValues = result.properties[20].values;
            const premioDesc = result.properties[21].value;
            const frazPremioValue = result.properties[22].value;
            const frazPremioValues = result.properties[22].values;
            const durata = result.properties[23].value;
            const etaMaxAllaSottoscrizioneValue = result.properties[24].value;
            const etaMaxAllaSottoscrizioneValueSign = result.properties[24].valueSign;
            const etaMaxAllaScadenzaValue = result.properties[25].value;
            const etaMaxAllaScadenzaValueSign = result.properties[25].valueSign;
            const documentazioneRichiesta = result.properties[26].value;
            const rischiAssicuratiRamoVitaValue = result.properties[27].value;
            const rischiAssicuratiRamoVitaValues = result.properties[27].values;
            const rischiAssicuratiRamoDanniValue = result.properties[28].value;
            const rischiAssicuratiRamoDanniValues = result.properties[28].values;
            const decessoQualsiasiCausaCode = result.properties[29].code;
            const decessoQualsiasiCausaValue = result.properties[29].value;
            const decessoQualsiasiCausaPrestazione = result.properties[30].value;
            const decessoDaInfortunioCode = result.properties[31].code;
            const decessoDaInfortunioValue = result.properties[31].value;
            const decessoDaInfortunioPrestazione = result.properties[32].value;
            const decessoDaMalattiaCode = result.properties[33].code;
            const decessoDaMalattiaValue = result.properties[33].value;
            const decessoDaMalattiaPrestazione = result.properties[34].value;
            const invaliditaPermanenteQualsiasiCausaCode = result.properties[35].code;
            const invaliditaPermanenteQualsiasiCausaValue = result.properties[35].value;
            const invaliditaPermanenteQualsiasiCausaPrestazione = result.properties[36].value;
            const invaliditaPermanenteDaInfortunioCode = result.properties[37].code;
            const invaliditaPermanenteDaInfortunioValue = result.properties[37].value;
            const invaliditaPermanenteDaInfortunioPrestazione = result.properties[38].value;
            const invaliditaPermanenteDaMalattiaCode = result.properties[39].code;
            const invaliditaPermanenteDaMalattiaValue = result.properties[39].value;
            const invaliditaPermanenteDaMalattiaPrestazione = result.properties[40].value;
            const inabilitaTemporaneaQualsiasiCausaCode = result.properties[41].code;
            const inabilitaTemporaneaQualsiasiCausaValue = result.properties[41].value;
            const inabilitaTemporaneaQualsiasiCausaPrestazione = result.properties[42].value;
            const inabilitaTemporaneaDaInfortunioCode = result.properties[43].code;
            const inabilitaTemporaneaDaInfortunioValue = result.properties[43].value;
            const inabilitaTemporaneaDaInfortunioPrestazione = result.properties[44].value;
            const inabilitaTemporaneaDaMalattiaCode = result.properties[45].code;
            const inabilitaTemporaneaDaMalattiaValue = result.properties[45].value;
            const inabilitaTemporaneaDaMalattiaPrestazione = result.properties[46].value;
            const malattieGraviCode = result.properties[47].code;
            const malattieGraviValue = result.properties[47].value;
            const malattieGraviPrestazione = result.properties[48].value;
            const ricoveroOspedalieroCode = result.properties[49].code;
            const ricoveroOspedalieroValue = result.properties[49].value;
            const ricoveroOspedalieroPrestazione = result.properties[50].value;
            const ricoveroGrandeInterventoChirurgicoCode = result.properties[51].code;
            const ricoveroGrandeInterventoChirurgicoValue = result.properties[51].value;
            const ricoveroGrandeInterventoChirurgicoPrestazione = result.properties[51].value;
            const perditaImpiegoCode = result.properties[53].code;
            const perditaImpiegoValue = result.properties[53].value;
            const perditaImpiegoPrestazione = result.properties[54].value;
            const altriRischi = result.properties[55].value;
            const costiRamoVitaValue = result.properties[56].value;
            const costiRamoVitaValueSign = result.properties[56].valueSign;
            const costiRamoDanniValue = result.properties[57].value;
            const costiRamoDanniValueSign = result.properties[57].valueSign;
            const interessiFrazValue = result.properties[58].value;
            const interessiFrazFrazionamento = result.properties[58].frazionamento;
            const retrDistribRamoVitaValue = result.properties[59].value;
            const retrDistribRamoVitaValueSign = result.properties[59].valueSign;
            const retrDistribRamoDanniValue = result.properties[60].value;
            const retrDistribRamoDanniValueSign = result.properties[60].valueSign;
            const retrDistrSpecifiche = result.properties[61].value;
            const note = result.properties[62].value;
            const codProdotto = result.properties[63].value;

            // prodotto
            properties.prodottoProperty.value = prodotto;
            properties.codProdottoProperty.value = codProdotto;
            // piuTariffe
            selectChoices.piuTariffe = vm.prefillCodeValue(properties.piuTariffeProperty, piuTariffeCode, piuTariffeValue, selectChoices.piuTariffe, vm.piuTariffeOptions);            
            // prodotti collegati
            properties.codProdCollegatoProperty.value = codProdottiCollegati;
            // compagnia
            selectChoices.compagnia = vm.prefillValues(properties.compagniaProperty, compagniaValues, selectChoices.compagnia, vm.compagniaOptions);
            // canale
            selectChoices.canale = vm.prefillValues(properties.canaleProperty,canaleValues,selectChoices.canale,vm.canaleOptions);
            // distributori
            selectChoices.distributori = vm.prefillValues(properties.distributoriProperty,distributoriValues,selectChoices.distributori,vm.distributoriOptions);
            // modalità di distribuzione
            selectChoices.modDistribuzione = vm.prefillValues(properties.modDistribuzioneProperty,modDistribuzioneValues,selectChoices.modDistribuzione,vm.modDistribuzioneOptions);
            // mercato
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty,mercatoValues,selectChoices.mercato,vm.mercatoOptions);
            // destinatari
            properties.destinatariProperty.value = destinatari;
            // target market
            properties.targetMarketProperty.value = targetMarket;
            // desc prodotto
            properties.descProdottoProperty.value = descProdotto;
            // linea business
            properties.lineaBusinessProperty.value = lineaBusiness;
            // ramo
            selectChoices.ramo = vm.prefillValues(properties.ramoProperty,ramoValues,selectChoices.ramo,vm.ramoOptions);
            // tipologia garanzie
            selectChoices.tipologiaGaranzie = vm.prefillValues(properties.tipologiaGaranzieProperty,tipologiaGaranzieValues,selectChoices.tipologiaGaranzie,vm.tipologiaGaranzieOptions);
            // combinazione garanzie
            properties.combinazioneGaranzieProperty.value = combinazioneGaranzie;
            // prodotto in commercio
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            // inizio commercializzazione
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            // fine commercializzazione
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            // edizione DIP aggiuntivo
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            // tipologia di assicurazione
            selectChoices.tipologiaAssicurazione = vm.prefillCodeValue(properties.tipologiaAssicurazioneProperty, tipologiaAssicurazioneCode, tipologiaAssicurazioneValue, selectChoices.tipologiaAssicurazione, vm.tipologiaAssicurazioneOptions);
            // premio - tipologia
            selectChoices.premioTipologia = vm.prefillValues(properties.premioTipologiaProperty,premioTipologiaValues,selectChoices.premioTipologia,vm.premioTipologiaOptions);
            // premio - descrizione
            properties.premioDescProperty.value = premioDesc;
            // frazionamento del premio
            properties.frazPremioProperty.value = frazPremioValue;
            selectChoices.frazPremio = vm.prefillValues(properties.frazPremioProperty,frazPremioValues,selectChoices.frazPremio,vm.frazPremioOptions);
            // durata contrattuale
            properties.durataProperty.value = durata;
            // età massima alla sottoscrizione
            properties.etaMaxAllaSottoscrizioneProperty.value = etaMaxAllaSottoscrizioneValue;
            properties.etaMaxAllaSottoscrizioneProperty.valueSign = etaMaxAllaSottoscrizioneValueSign;
            // età massima alla scadenza
            properties.etaMaxAllaScadenzaProperty.value = etaMaxAllaScadenzaValue;
            properties.etaMaxAllaScadenzaProperty.valueSign = etaMaxAllaScadenzaValueSign;
            // documentazione richiesta
            properties.docRichiestaProperty.value = documentazioneRichiesta;
            // rischi assicurati ramo vita
            properties.rischiAssicuratiRamoVitaProperty.value = rischiAssicuratiRamoVitaValue;
            selectChoices.rischiAssicuratiRamoVita = vm.prefillValues(properties.rischiAssicuratiRamoVitaProperty,rischiAssicuratiRamoVitaValues,selectChoices.rischiAssicuratiRamoVita,vm.rischiAssicuratiRamoVitaOptions);
            // rischi assicurati ramo danni
            properties.rischiAssicuratiRamoDanniProperty.value = rischiAssicuratiRamoDanniValue;
            selectChoices.rischiAssicuratiRamoDanni = vm.prefillValues(properties.rischiAssicuratiRamoDanniProperty,rischiAssicuratiRamoDanniValues,selectChoices.rischiAssicuratiRamoDanni,vm.rischiAssicuratiRamoDanniOptions);
            // decesso qualsiasi causa
            selectChoices.decessoQualsiasiCausa = vm.prefillCodeValue(properties.decessoQualsiasiCausaProperty, decessoQualsiasiCausaCode, decessoQualsiasiCausaValue, selectChoices.decessoQualsiasiCausa, vm.decessoQualsiasiCausaOptions);
            // decesso qualsiasi causa - prestazione
            properties.decessoQualsiasiCausaPrestazioneProperty.value = decessoQualsiasiCausaPrestazione;
            // decesso da infortunio
            selectChoices.decessoDaInfortunio = vm.prefillCodeValue(properties.decessoDaInfortunioProperty, decessoDaInfortunioCode, decessoDaInfortunioValue, selectChoices.decessoDaInfortunio, vm.decessoDaInfortunioOptions);
            // decesso da infortunio - prestazione
            properties.decessoDaInfortunioPrestazioneProperty.value = decessoDaInfortunioPrestazione;
            // decesso da malattia
            selectChoices.decessoDaMalattia = vm.prefillCodeValue(properties.decessoDaMalattiaProperty, decessoDaMalattiaCode, decessoDaMalattiaValue, selectChoices.decessoDaMalattia, vm.decessoDaMalattiaOptions);
            // decesso da malattia - prestazione
            properties.decessoDaMalattiaPrestazioneProperty.value = decessoDaMalattiaPrestazione;
            // invalidità permanente qualsiasi causa
            selectChoices.invaliditaPermanenteQualsiasiCausa = vm.prefillCodeValue(properties.invaliditaPermanenteQualsiasiCausaProperty, invaliditaPermanenteQualsiasiCausaCode, invaliditaPermanenteQualsiasiCausaValue, selectChoices.invaliditaPermanenteQualsiasiCausa, vm.invaliditaPermanenteQualsiasiCausaOptions);
            // invalidità permanente qualsiasi causa - prestazione
            properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = invaliditaPermanenteQualsiasiCausaPrestazione;
            // invalidità permanente da infortunio
            selectChoices.invaliditaPermanenteDaInfortunio = vm.prefillCodeValue(properties.invaliditaPermanenteDaInfortunioProperty, invaliditaPermanenteDaInfortunioCode, invaliditaPermanenteDaInfortunioValue, selectChoices.invaliditaPermanenteDaInfortunio, vm.invaliditaPermanenteDaInfortunioOptions);
            // invalidità permanente da infortunio - prestazione
            properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = invaliditaPermanenteDaInfortunioPrestazione;
            // invalidità permanente da malattia
            selectChoices.invaliditaPermanenteDaMalattia = vm.prefillCodeValue(properties.invaliditaPermanenteDaMalattiaProperty, invaliditaPermanenteDaMalattiaCode, invaliditaPermanenteDaMalattiaValue, selectChoices.invaliditaPermanenteDaMalattia, vm.invaliditaPermanenteDaMalattiaOptions);
            // invalidità permanente da malattia - prestazione
            properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = invaliditaPermanenteDaMalattiaPrestazione;
            // inabilità temporanea qualsiasi causa
            selectChoices.inabilitaTemporaneaQualsiasiCausa = vm.prefillCodeValue(properties.inabilitaTemporaneaQualsiasiCausaProperty, inabilitaTemporaneaQualsiasiCausaCode, inabilitaTemporaneaQualsiasiCausaValue, selectChoices.inabilitaTemporaneaQualsiasiCausa, vm.inabilitaTemporaneaQualsiasiCausaOptions);
            // inabilità temporanea qualsiasi causa - prestazione
            properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = inabilitaTemporaneaQualsiasiCausaPrestazione;
            // inabilità temporanea da infortunio
            selectChoices.inabilitaTemporaneaDaInfortunio = vm.prefillCodeValue(properties.inabilitaTemporaneaDaInfortunioProperty, inabilitaTemporaneaDaInfortunioCode, inabilitaTemporaneaDaInfortunioValue, selectChoices.inabilitaTemporaneaDaInfortunio, vm.inabilitaTemporaneaDaInfortunioOptions);
            // inabilità temporanea da infortunio - prestazione
            properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = inabilitaTemporaneaDaInfortunioPrestazione;
            // inabilità temporanea da malattia
            selectChoices.inabilitaTemporaneaDaMalattia = vm.prefillCodeValue(properties.inabilitaTemporaneaDaMalattiaProperty, inabilitaTemporaneaDaMalattiaCode, inabilitaTemporaneaDaMalattiaValue, selectChoices.inabilitaTemporaneaDaMalattia, vm.inabilitaTemporaneaDaMalattiaOptions);
            // inabilità temporanea da malattia - prestazione
            properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = inabilitaTemporaneaDaMalattiaPrestazione;
            // malattie gravi
            selectChoices.malattieGravi = vm.prefillCodeValue(properties.malattieGraviProperty, malattieGraviCode, malattieGraviValue, selectChoices.malattieGravi, vm.malattieGraviOptions);
            // malattie gravi - prestazione
            properties.malattieGraviPrestazioneProperty.value = malattieGraviPrestazione;
            // ricovero ospedaliero
            selectChoices.ricoveroOspedaliero = vm.prefillCodeValue(properties.ricoveroOspedalieroProperty, ricoveroOspedalieroCode, ricoveroOspedalieroValue, selectChoices.ricoveroOspedaliero, vm.ricoveroOspedalieroOptions);
            // ricovero ospedaliero - prestazione
            properties.ricoveroOspedalieroPrestazioneProperty.value = ricoveroOspedalieroPrestazione;
            // ricovero grande intervento chirurgico
            selectChoices.ricoveroGrandeInterventoChirurgico = vm.prefillCodeValue(properties.ricoveroGrandeInterventoChirurgicoProperty, ricoveroGrandeInterventoChirurgicoCode, ricoveroGrandeInterventoChirurgicoValue, selectChoices.ricoveroGrandeInterventoChirurgico, vm.ricoveroGrandeInterventoChirurgicoOptions);
            // ricovero grande intervento chirurgico - prestazione
            properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = ricoveroGrandeInterventoChirurgicoPrestazione;
            // perdita impiego
            selectChoices.perditaImpiego = vm.prefillCodeValue(properties.perditaImpiegoProperty, perditaImpiegoCode, perditaImpiegoValue, selectChoices.perditaImpiego, vm.perditaImpiegoOptions);
            // perdita impiego - prestazione
            properties.perditaImpiegoPrestazioneProperty.value = perditaImpiegoPrestazione;
            // altri rischi
            properties.altriRischiProperty.value = altriRischi;
            // costi ramo vita
            properties.costiRamoVitaProperty.value = costiRamoVitaValue;
            properties.costiRamoVitaProperty.valueSign = costiRamoVitaValueSign;
            // costi ramo danni
            properties.costiRamoDanniProperty.value = costiRamoDanniValue;
            properties.costiRamoDanniProperty.valueSign = costiRamoDanniValueSign;
            // interessi di frazionamento
            properties.interessiFrazProperty.value = interessiFrazValue;
            properties.interessiFrazProperty.frazionamento = interessiFrazFrazionamento;
            // retrocessione alla distribuzione ramo vita
            properties.retrDistrVitaProperty.value = retrDistribRamoVitaValue;
            properties.retrDistrVitaProperty.valueSign = retrDistribRamoVitaValueSign;
            // retrocessione alla distribuzione ramo vita
            properties.retrDistrDanniProperty.value = retrDistribRamoDanniValue;
            properties.retrDistrDanniProperty.valueSign = retrDistribRamoDanniValueSign;
            // retrocessione alla distribuzione specifiche
            properties.retrDistrSpecificheProperty.value = retrDistrSpecifiche;
            // note
            properties.noteProperty.value = note;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        // valori fissi
        properties.lineaBusinessProperty.value = "Protezione Credito/Pagamenti/Entrate";

        // change
        vm.changePiuTariffe();
        vm.changeFineComm();
        vm.changePremioTipologia();
        vm.changeRamo();
        vm.changeFrazPremio();
        vm.changeRischiAssicurati();
      }

      vm.initSettingRamo();
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "16.2" || properties.prodCommercioProperty.code == "") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    preparePropList() {
      const vm = this as any;

      vm.setDatePropertiesValue();

      vm.propList = [
        properties.prodottoProperty,
        properties.piuTariffeProperty,
        properties.codProdCollegatoProperty,
        properties.compagniaProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.modDistribuzioneProperty,
        properties.mercatoProperty,
        properties.destinatariProperty,
        properties.targetMarketProperty,
        properties.descProdottoProperty,
        properties.lineaBusinessProperty,
        properties.ramoProperty,
        properties.tipologiaGaranzieProperty,
        properties.combinazioneGaranzieProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipologiaAssicurazioneProperty,
        properties.premioTipologiaProperty,
        properties.premioDescProperty,
        properties.frazPremioProperty,
        properties.durataProperty,
        properties.etaMaxAllaSottoscrizioneProperty,
        properties.etaMaxAllaScadenzaProperty,
        properties.docRichiestaProperty,
        properties.rischiAssicuratiRamoVitaProperty,
        properties.rischiAssicuratiRamoDanniProperty,
        properties.decessoQualsiasiCausaProperty,
        properties.decessoQualsiasiCausaPrestazioneProperty,
        properties.decessoDaInfortunioProperty,
        properties.decessoDaInfortunioPrestazioneProperty,
        properties.decessoDaMalattiaProperty,
        properties.decessoDaMalattiaPrestazioneProperty,
        properties.invaliditaPermanenteQualsiasiCausaProperty,
        properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty,
        properties.invaliditaPermanenteDaInfortunioProperty,
        properties.invaliditaPermanenteDaInfortunioPrestazioneProperty,
        properties.invaliditaPermanenteDaMalattiaProperty,
        properties.invaliditaPermanenteDaMalattiaPrestazioneProperty,
        properties.inabilitaTemporaneaQualsiasiCausaProperty,
        properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty,
        properties.inabilitaTemporaneaDaInfortunioProperty,
        properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty,
        properties.inabilitaTemporaneaDaMalattiaProperty,
        properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty,
        properties.malattieGraviProperty,
        properties.malattieGraviPrestazioneProperty,
        properties.ricoveroOspedalieroProperty,
        properties.ricoveroOspedalieroPrestazioneProperty,
        properties.ricoveroGrandeInterventoChirurgicoProperty,
        properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty,
        properties.perditaImpiegoProperty,
        properties.perditaImpiegoPrestazioneProperty,
        properties.altriRischiProperty,
        properties.costiRamoVitaProperty,
        properties.costiRamoDanniProperty,
        properties.interessiFrazProperty,
        properties.retrDistrVitaProperty,
        properties.retrDistrDanniProperty,
        properties.retrDistrSpecificheProperty,
        properties.noteProperty,
        properties.codProdottoProperty,
      ];
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.CPI_PPI, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
          }
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          printableValue = property.value;
        } else {
          let values = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + s + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + s + "</li>";
            }).join("");
            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          const valueAndSign = property.value + ((property.valueSign !== undefined && property.valueSign !== null) ? " " + property.valueSign : "");          

          if (valueAndSign.length > maxCharsPerRow) {

            for (let i = 0; i < valueAndSign.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, valueAndSign.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + valueAndSign.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = valueAndSign;
            }
          } else {
            printableValue = valueAndSign;
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    //
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      const cc = this.customCategory || 'protezione-credito';
      return requestService.initProductWithCustomCategory(categories.CPI_PPI, cc).then(handleResponse);
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('cpi-ppi') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },
});
